import { Link } from 'react-router-dom';
import Logo from '../../Data/Assets/images/IYNS_new_logo.png';
import './navbar.css';

function Navbar() {
  return (
    <div id="navbar">
      <nav className="navbar navbar-expand-xl bg-body-tertiary">
        <div className="container-fluid" style={{ paddingRight: '1rem' }}>
          <Link className="navbar-brand" to="/" id="logo">
            <img
              src={Logo}
              alt="Logo"
              className="align-text-top"
              style={{ width: '84px', height: '90px', padding: 0 }}
            />
          </Link>

          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Nav Items */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav" id="navList">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/internships">
                  Internships
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/exclusive">
                  Exclusive
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Activities
                </Link>
                {/* /Career router*/}
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Events
                </Link>
                {/* /events reouter */}
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
            <Link to="/membership-form">
              <button className="btn btn-primary" id="member-button">
                Become a Member
              </button>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
